<div class="pt-page exw-pt-page" data-source="scoped_example">
  <div class="pt-header">
    <div class="pt-header-main">
      <h1 class="pt-title">Productivity Trends</h1>
      <p class="pt-header-subtitle pt-subtitle">{{ trends.subtitle }}</p>
    </div>
    <div class="pt-header-filters">
      <button type="button" class="pt-filter-trigger" disabled aria-disabled="true">
        <mat-icon class="pt-filter-trigger-icon" fontSet="material-symbols-outlined" aria-hidden="true">filter_alt</mat-icon>
        <span>{{ trends.filterLabel }}</span>
      </button>
      <div class="pt-filter-summary">{{ trends.filterSummary }}</div>
      <div class="pt-filter-meta">Example · sample data</div>
    </div>
  </div>

  <div class="pt-tabs" role="tablist" aria-label="Productivity Trends sections">
    <button
      type="button"
      class="pt-tab"
      *ngFor="let tab of tabs"
      [class.pt-active]="activeTab === tab.key"
      [class.pt-tab--locked]="tab.locked"
      [attr.title]="tab.locked ? 'Shown in full product · sample unlocks Overview, Attention Signals, and Deep Work' : null"
      (click)="selectTab(tab.key, tab.locked)">
      {{ tab.label }}
      <span *ngIf="tab.locked" class="material-symbols-outlined pt-tab-lock-icon" aria-hidden="true">lock</span>
    </button>
  </div>

  <!-- Overview -->
  <div class="pt-section pt-overview-flow pt-executive-section" *ngIf="activeTab === 'overview'">
    <section class="pt-section-block pt-recap-block">
      <header class="pt-section-header pt-recap-header">
        <h3 class="pt-section-title">What changed this period</h3>
        <p class="pt-section-subtitle">Auto-generated from the current and prior period - read this before scrolling.</p>
      </header>
      <ul class="pt-recap-list">
        <li class="pt-recap-item" *ngFor="let b of trends.recap" [attr.data-tone]="b.tone">
          <span class="pt-recap-icon">
            <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">{{ b.icon }}</mat-icon>
          </span>
          <span class="pt-recap-text">{{ b.text }}</span>
        </li>
      </ul>
    </section>

    <section class="pt-section-block">
      <header class="pt-section-header">
        <h3 class="pt-section-title">Executive Snapshot</h3>
        <p class="pt-section-subtitle">High-level signals for the selected date range.</p>
      </header>
      <div class="pt-executive-status-row">
        <div class="pt-overall-status">
          <span class="pt-status-pill pt-status-pill--monitor">{{ trends.healthPill }}</span>
          <span class="pt-overall-status-detail">{{ trends.healthDetail }}</span>
        </div>
      </div>
      <div class="pt-snapshot-grid">
        <div class="pt-card pt-snapshot-card" *ngFor="let tile of trends.snapshot">
          <div class="pt-snapshot-main">
            <div class="pt-card-label">{{ tile.label }}</div>
            <div class="pt-card-value">{{ tile.value }}</div>
            <div class="pt-card-helper pt-snapshot-context">{{ tile.context }}</div>
          </div>
          <div class="pt-card-footer">
            <span
              class="pt-badge"
              [class.pt-badge-good]="tile.statusTone === 'good'"
              [class.pt-badge-warning]="tile.statusTone === 'warning'"
              [class.pt-badge-risk]="tile.statusTone === 'risk'"
              [class.pt-badge-muted]="tile.statusTone === 'muted'">{{ tile.status }}</span>
            <span class="pt-link pt-card-footer-action pt-snapshot-footer-hint">{{ tile.action }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="pt-section-block pt-management-section">
      <div class="pt-management-card pt-card pt-management-card--compact">
        <div class="pt-management-compact-head">
          <h3 class="pt-section-title">Management Summary</h3>
          <span class="pt-badge pt-badge-good">Sample reliable</span>
        </div>
        <p class="pt-management-summary-text">{{ trends.managementSummary }}</p>
        <details class="pt-management-details">
          <summary class="pt-management-details-summary">
            <mat-icon class="pt-management-details-chevron" fontSet="material-symbols-outlined" aria-hidden="true">expand_more</mat-icon>
            Details
          </summary>
          <div class="pt-management-details-body">
            <ul class="pt-management-details-list">
              <li *ngFor="let line of trends.managementDetails">{{ line }}</li>
            </ul>
          </div>
        </details>
        <div class="pt-management-actions" role="group" aria-label="Recommended next steps">
          <button type="button" class="pt-management-action" (click)="goAttention()">View Attention</button>
          <button type="button" class="pt-management-action" (click)="goDeepWork()">View Deep Work</button>
          <button type="button" class="pt-management-action" disabled>View Workload</button>
        </div>
      </div>
    </section>

    <section class="pt-section-block pt-section-block--kpis">
      <header class="pt-section-header">
        <h4 class="pt-section-title">Key Performance Indicators</h4>
        <p class="pt-section-subtitle">Core numbers for the selected date range.</p>
      </header>
      <div class="pt-kpi-grid">
        <div class="pt-card pt-kpi-card" *ngFor="let kpi of trends.kpis">
          <div class="pt-kpi-label">{{ kpi.label }}</div>
          <div class="pt-kpi-value">{{ kpi.value }}</div>
          <div class="pt-kpi-badge-row" *ngIf="kpi.badge">
            <span class="pt-kpi-badge">{{ kpi.badge }}</span>
          </div>
          <div class="pt-kpi-meta" *ngIf="kpi.helper">{{ kpi.helper }}</div>
          <div class="pt-kpi-meta" *ngIf="kpi.delta">{{ kpi.delta }}</div>
        </div>
      </div>
    </section>

    <section class="pt-section-block pt-section-block--contributors">
      <header class="pt-section-header">
        <h4 class="pt-section-title">Top Contributors to Key Metrics</h4>
        <p class="pt-section-subtitle">
          Use this section to identify who needs review, who is contributing strong activity, and who is driving deep work.
        </p>
      </header>

      <div class="pt-attention-panel">
        <div class="pt-attention-panel-main">
          <div class="pt-attention-panel-eyebrow">Needs Review</div>
          <div class="pt-attention-panel-title">{{ trends.attentionHeadline }}</div>
          <div class="pt-attention-panel-meta">Main signal: {{ trends.attentionMainSignal }}</div>
        </div>
        <button type="button" class="pt-primary-btn pt-attention-panel-rec-btn" (click)="goAttention()">
          {{ trends.recommendedStep }} &rarr;
        </button>
      </div>

      <div class="pt-table-wrap">
        <div class="pt-subtitle-row">
          <div class="pt-overview-table-heading">
            <h4 class="pt-subtitle">Top Needing Attention</h4>
            <span class="pt-badge pt-badge-muted">Sample</span>
          </div>
          <button type="button" class="pt-secondary-btn" (click)="goAttention()">View all</button>
        </div>
        <div class="pt-card-desc">
          Employees with the strongest review signals based on score, idle behavior, and trend movement.
        </div>
        <table class="pt-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Score</th>
              <th>Idle</th>
              <th>Signal</th>
              <th>Why flagged</th>
              <th>Suggested review</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pt-clickable-row" *ngFor="let row of trends.needingAttention" (click)="openDrawer()">
              <td>
                <div class="pt-employee-profile">
                  <div class="pt-employee-profile-avatar">
                    <span class="pt-avatar-pill employee-avatar pt-employee-profile-initials" aria-hidden="true">{{ row.initials }}</span>
                  </div>
                  <div class="pt-employee-profile-text">
                    <div class="pt-employee-profile-name">{{ row.name }}</div>
                    <div class="pt-employee-profile-role" *ngIf="row.role">{{ row.role }}</div>
                  </div>
                </div>
              </td>
              <td>{{ row.score }}</td>
              <td>{{ row.idlePct }}</td>
              <td><span class="pt-badge pt-badge-warning">{{ row.signal }}</span></td>
              <td>{{ row.why }}</td>
              <td>{{ row.suggested }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pt-contributors-grid pt-overview-contributors-grid">
        <div class="pt-table-wrap">
          <div class="pt-subtitle-row">
            <div class="pt-overview-table-heading">
              <h4 class="pt-subtitle">Top 3 Productive Employees</h4>
              <span class="pt-badge pt-badge-muted">Sample</span>
            </div>
          </div>
          <div class="pt-card-desc">Highest activity-based productivity scores in the selected period.</div>
          <table class="pt-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Employee</th>
                <th>Score</th>
                <th>Active time</th>
              </tr>
            </thead>
            <tbody>
              <tr class="pt-clickable-row" *ngFor="let row of trends.topProductive; let i = index" (click)="openDrawer()">
                <td><span class="pt-rank-pill rank-pill">{{ i + 1 }}</span></td>
                <td>
                  <div class="pt-employee-profile">
                    <div class="pt-employee-profile-avatar">
                      <span class="pt-avatar-pill employee-avatar pt-employee-profile-initials" aria-hidden="true">{{ row.initials }}</span>
                    </div>
                    <div class="pt-employee-profile-text">
                      <div class="pt-employee-profile-name">{{ row.name }}</div>
                      <div class="pt-employee-profile-role" *ngIf="row.role">{{ row.role }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ row.score }}</td>
                <td>{{ row.activeTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="pt-table-wrap">
          <div class="pt-subtitle-row">
            <div class="pt-overview-table-heading">
              <h4 class="pt-subtitle">Top 3 Deep Work Champions</h4>
              <span class="pt-badge pt-badge-muted">Sample</span>
            </div>
            <button type="button" class="pt-secondary-btn" (click)="goDeepWork()">View all</button>
          </div>
          <div class="pt-card-desc">Highest deep-work share of active time in the selected period.</div>
          <table class="pt-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Employee</th>
                <th>Deep work %</th>
                <th>Deep work score</th>
              </tr>
            </thead>
            <tbody>
              <tr class="pt-clickable-row" *ngFor="let row of trends.topDeepWork; let i = index" (click)="openDrawer()">
                <td><span class="pt-rank-pill rank-pill">{{ i + 1 }}</span></td>
                <td>
                  <div class="pt-employee-profile">
                    <div class="pt-employee-profile-avatar">
                      <span class="pt-avatar-pill employee-avatar pt-employee-profile-initials" aria-hidden="true">{{ row.initials }}</span>
                    </div>
                    <div class="pt-employee-profile-text">
                      <div class="pt-employee-profile-name">{{ row.name }}</div>
                      <div class="pt-employee-profile-role" *ngIf="row.role">{{ row.role }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ row.deepWorkPct }}</td>
                <td>{{ row.deepWorkScore }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>

  <!-- Attention Signals -->
  <div *ngIf="activeTab === 'attention_signals'" class="pt-attention-workspace-shell">
    <div class="pt-attention-queue-header">
      <div class="pt-attention-workspace-eyebrow">Attention Signals</div>
      <h3 class="pt-attention-queue-title">Who needs a closer look</h3>
      <p class="pt-section-subtitle">Sample queue shaped like the product Attention Signals table.</p>
    </div>
    <div class="pt-table-wrap pt-attention-table-shell">
      <table class="pt-table pt-table--attention-queue">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Logged</th>
            <th>Active</th>
            <th>Idle %</th>
            <th>Δ Idle</th>
            <th>Comm %</th>
            <th>Deep work %</th>
            <th>Status</th>
            <th>Engagement Signal</th>
            <th>Reason</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="pt-attention-main-row"
            *ngFor="let row of trends.attentionQueue"
            (click)="openDrawer()">
            <td>
              <div class="pt-attention-emp-cell">
                <div class="pt-employee-profile">
                  <div class="pt-employee-profile-avatar">
                    <span class="pt-avatar-pill employee-avatar pt-employee-profile-initials" aria-hidden="true">{{ row.initials }}</span>
                  </div>
                  <div class="pt-employee-profile-text">
                    <div class="pt-employee-profile-name">{{ row.name }}</div>
                    <div class="pt-employee-profile-role" *ngIf="row.role">{{ row.role }}</div>
                  </div>
                </div>
                <div class="pt-attention-emp-team pt-attention-emp-team--below">{{ row.team }}</div>
              </div>
            </td>
            <td>{{ row.logged }}</td>
            <td>{{ row.active }}</td>
            <td>
              <div class="pt-idle-cell">
                <span>{{ row.idlePct }}%</span>
                <div class="pt-idle-cell-bar"><div class="pt-idle-cell-fill" [style.width.%]="row.idlePct"></div></div>
              </div>
            </td>
            <td>{{ row.deltaIdle }}</td>
            <td>{{ row.commPct }}</td>
            <td>{{ row.deepWorkPct }}</td>
            <td><span [class]="row.statusClass">{{ row.status }}</span></td>
            <td class="pt-attention-engagement-cell">
              <div class="pt-pill-group" *ngIf="row.pills.length">
                <span *ngFor="let p of row.pills" [class]="p.cssClass">{{ p.label }}</span>
              </div>
              <span *ngIf="!row.pills.length" class="pt-text-muted">—</span>
            </td>
            <td class="pt-attention-reason-cell">{{ row.reason }}</td>
            <td class="pt-attention-actions-cell">
              <div class="pt-attention-actions-inner">
                <button type="button" class="pt-attention-action-icon-btn pt-attention-action-icon-btn--primary" (click)="openDrawer(); $event.stopPropagation()">
                  <span class="material-symbols-outlined" aria-hidden="true">visibility</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Deep Work -->
  <div *ngIf="activeTab === 'deep_work'">
    <div class="pt-visual-card">
      <h4 class="pt-subtitle pt-section-title">Deep Work Analysis</h4>
      <div class="pt-section-desc">Sustained focus sessions based on selected duration, productivity, and distraction rules.</div>
      <div class="muted">Current rule: {{ trends.deepWorkRule }}</div>
      <div class="pt-info-banner">{{ trends.deepWorkBanner }}</div>
      <div class="pt-kpis pt-kpis--compact">
        <div class="pt-kpi" *ngFor="let kpi of trends.deepWorkKpis">
          <div class="pt-kpi-label">{{ kpi.label }}</div>
          <div class="pt-kpi-value">{{ kpi.value }}</div>
        </div>
      </div>
    </div>

    <div class="pt-table-wrap pt-deep-work-employee-wrap">
      <h4 class="pt-subtitle">Deep Work by Employee</h4>
      <table class="pt-table pt-table--comparison">
        <thead>
          <tr>
            <th>Employee</th>
            <th>Deep Work Hours</th>
            <th>Sessions</th>
            <th>Avg Session (hrs)</th>
            <th>Active Hours</th>
            <th>Total Hours</th>
            <th>% of Active Time</th>
          </tr>
        </thead>
        <tbody>
          <tr class="pt-clickable-row" *ngFor="let row of trends.deepWorkEmployees" (click)="openDrawer()">
            <td>
              <div class="pt-employee-profile">
                <div class="pt-employee-profile-avatar">
                  <span class="pt-avatar-pill employee-avatar pt-employee-profile-initials" aria-hidden="true">{{ row.initials }}</span>
                </div>
                <div class="pt-employee-profile-text">
                  <div class="pt-employee-profile-name">{{ row.name }}</div>
                  <div class="pt-employee-profile-role" *ngIf="row.role">{{ row.role }}</div>
                </div>
              </div>
            </td>
            <td>{{ row.deepWorkHours }}</td>
            <td>{{ row.sessions }}</td>
            <td>{{ row.avgSession }}</td>
            <td>{{ row.activeHours }}</td>
            <td>{{ row.totalHours }}</td>
            <td>{{ row.pctOfActive }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pt-grid-2">
      <div class="pt-visual-card">
        <h4 class="pt-subtitle">Top Deep Work Sources</h4>
        <div class="pt-bars">
          <div class="pt-bar-row" *ngFor="let src of trends.deepWorkSources">
            <div class="pt-bar-label">{{ src.label }}</div>
            <div class="pt-bar-track">
              <div class="pt-bar-fill pt-bar-fill--advanced" [style.width.%]="src.pct"></div>
            </div>
            <div class="pt-bar-value">{{ src.hours }}</div>
          </div>
        </div>
      </div>
      <div class="pt-visual-card">
        <h4 class="pt-subtitle">Top Tools for Deep Work</h4>
        <ul class="pt-source-list">
          <li *ngFor="let src of trends.deepWorkSources">
            <strong>{{ src.label }}</strong>
            <span>{{ src.hours }} · {{ src.pct }}%</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Employee drawer — same chrome as real PT quick drawer -->
  <div class="pt-drawer-backdrop" *ngIf="drawerOpen" (click)="closeDrawer()"></div>
  <aside class="pt-quick-drawer" *ngIf="drawerOpen" role="dialog" aria-label="Employee deep work preview">
    <div class="pt-quick-drawer-head">
      <div class="pt-quick-drawer-head-main">
        <div class="pt-quick-drawer-avatar">
          <span
            class="pt-avatar-pill employee-avatar pt-employee-profile-initials pt-employee-profile-initials--drawer"
            aria-hidden="true">{{ trends.drawer.initials }}</span>
        </div>
        <div class="pt-quick-drawer-head-text">
          <div class="pt-quick-drawer-eyebrow">Deep Work</div>
          <div class="pt-quick-drawer-title">{{ trends.drawer.name }}</div>
          <div class="pt-quick-drawer-period pt-text-muted">{{ trends.drawer.period }}</div>
        </div>
      </div>
      <button type="button" class="pt-quick-drawer-close" (click)="closeDrawer()" aria-label="Close">×</button>
    </div>

    <div class="pt-quick-drawer-body">
      <div class="pt-drawer-snapshot">
        <p class="pt-drawer-snapshot-headline">{{ trends.drawer.headline }}</p>
        <p class="pt-drawer-snapshot-subline">{{ trends.drawer.subline }}</p>
        <div class="pt-drawer-coverage">
          <div class="pt-drawer-coverage-strip" aria-hidden="true">
            <span
              *ngFor="let d of trends.drawer.coverage"
              class="pt-drawer-coverage-day"
              [class.pt-drawer-coverage-day--worked]="d === 'worked'"
              [class.pt-drawer-coverage-day--light]="d === 'light'"
              [class.pt-drawer-coverage-day--silent]="d === 'silent'"></span>
          </div>
          <div class="pt-drawer-coverage-legend">
            <span><i class="pt-drawer-coverage-dot pt-drawer-coverage-dot--worked" aria-hidden="true"></i> Worked</span>
            <span><i class="pt-drawer-coverage-dot pt-drawer-coverage-dot--light" aria-hidden="true"></i> Light</span>
            <span><i class="pt-drawer-coverage-dot pt-drawer-coverage-dot--silent" aria-hidden="true"></i> No work</span>
          </div>
        </div>
        <div class="pt-drawer-snapshot-kpis">
          <div class="pt-drawer-snapshot-kpi" *ngFor="let k of trends.drawer.kpis">
            <span class="pt-text-muted">{{ k.label }}</span>
            <strong>{{ k.value }}</strong>
          </div>
        </div>
      </div>

      <div class="pt-drawer-chip-row">
        <span class="pt-chip pt-chip--drawer" *ngFor="let chip of trends.drawer.chips">{{ chip }}</span>
      </div>

      <div class="pt-drawer-chart-block">
        <div class="pt-drawer-chart-title">Where did the time go?</div>
        <div class="pt-drawer-time-section">
          <div class="pt-drawer-time-subhead">By type of work</div>
          <div class="pt-drawer-time-list">
            <div class="pt-drawer-time-row" *ngFor="let c of trends.drawer.categories">
              <div class="pt-drawer-time-row-head">
                <span class="pt-drawer-time-name">{{ c.label }}</span>
                <span class="pt-drawer-time-value">{{ c.hoursLabel }} · {{ c.sharePct }}%</span>
              </div>
              <div class="pt-drawer-time-bar">
                <div class="pt-drawer-time-bar-fill" [style.width.%]="c.barPct"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pt-drawer-time-section">
          <div class="pt-drawer-time-subhead">Top apps &amp; sites</div>
          <div class="pt-drawer-time-list">
            <div class="pt-drawer-time-row" *ngFor="let app of trends.drawer.topApps">
              <div class="pt-drawer-time-row-head">
                <span class="pt-drawer-time-name">{{ app.label }}</span>
                <span class="pt-drawer-time-value">{{ app.hoursLabel }} · {{ app.sharePct }}%</span>
              </div>
              <div class="pt-drawer-time-bar">
                <div class="pt-drawer-time-bar-fill" [style.width.%]="app.barPct"></div>
              </div>
            </div>
          </div>
        </div>
        <p class="pt-drawer-time-foot">Share of active work time across top apps and sites.</p>
      </div>
    </div>
  </aside>
</div>
